import { lazyGetQuickStepsSections } from 'owa-mail-ribbon-sections/lib/sections';

import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import { setMenuDefinition } from '../../mutatorActions/setMenuDefinition';

export const onQuickStepsMenuClicked = (props: ReadOnlyRibbonControlDefProps): void => {
    lazyGetQuickStepsSections.import().then(getQuickStepsSections => {
        setMenuDefinition('QuickStepsMenuDefinitionStore', props.projectionTabId, () => {
            return {
                sections: getQuickStepsSections(props),
            };
        });
    });
};
